import styles from "./StorageHandling.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Product template — storage & handling band (Figma `4670-7260` / mobile
 * `5597-7501`): eyebrow, heading, then N bordered panels, each with an icon, its
 * own heading and a bulleted list.
 *
 * Deliberately NOT `SplitColumns`, which is the closest existing component: that
 * one renders grey panels separated by a gap-as-divider with no icon slot, while
 * these are white bordered cards led by a 32px glyph. Panel count is
 * `columns.length`, so a 3-up variant needs no code change.
 *
 * `items` is the bullet list; a panel may instead/also carry `body` paragraphs.
 */
export default function StorageHandling({
  eyebrow,
  heading,
  columns = [],
  surface = "light",
}) {
  if (!columns.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}

        <div className={styles.grid} style={{ "--cols": columns.length }}>
          {columns.map((col, i) => {
            const paras = Array.isArray(col.body)
              ? col.body
              : col.body
                ? [col.body]
                : [];

            return (
              <div className={styles.panel} key={i}>
                {col.icon && (
                  <span className={styles.icon}>
                    <img src={resolveIcon(col.icon)} alt="" aria-hidden="true" />
                  </span>
                )}
                {col.heading && (
                  <h3 className={styles.panelHeading}>{col.heading}</h3>
                )}

                {paras.map((p, j) => (
                  <p className={styles.para} key={j}>
                    {p}
                  </p>
                ))}

                {col.items?.length > 0 && (
                  <ul className={styles.list}>
                    {col.items.map((li, j) => (
                      <li className={styles.listItem} key={j}>
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
